import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { clearUserProfile } from '../../../../redux/actions/user';
import { clearBugsnagUser } from '../../../../redux/actions/bugsnag';
import Alerts from '../../../../prototypes/Alerts';
import EtelAPI from '../../../../api/EtelAPI';
import EditSectionLabel from '../../../../presentation/EditSectionLabel';
import EditSectionDropdown from '../../../../presentation/EditSectionDropdown';
import EditSectionInput from '../../../../presentation/EditSectionInput';
import EditSectionCheckBox from '../../../../presentation/EditSectionCheckBox';
import Select from 'react-select';

class WholesaleSettings extends Component {
  constructor( props ) {
    super( props );

    this.state = {
      row: props.row === undefined ? {} : props.row,
      resporgs: [],
      carriers: [],
      riskTypes: [],
      canadaRouteTypes: [],
      changed: false
    };

    this.onHandleMultiSelectChange = this.onHandleMultiSelectChange.bind( this );
    this.onHandleChange = this.onHandleChange.bind( this );
    this.onHandleException = this.onHandleException.bind( this );
  }

  /****************************************************************************
   * STATE / LIFECYCLE METHODS
   ***************************************************************************/

  componentDidMount() {
    this.getData();
  }

  /****************************************************************************
   * API CALLS
   ***************************************************************************/

  getData() {
    if ( this.state.row.Company_ID !== -1 ) {
      const companyParams = [
        { Company_ID: this.state.row.Company_ID }
      ];


      this.getWholesaleCompany( companyParams ).then( ( companyResults ) => {
        this.setState( {
          row: companyResults[0]
        }, () => {
          this.props.onChange( this.state.row ); // Send the row to the dialog
        } );
      } ).catch( ( exception ) => {
        this.onHandleException( exception );
      } );
    }

    const all = () => Promise.all( [
      this.getResporgs( [] ),
      this.getCarriers( [] ),
      this.getRiskTypes( ),
      this.getCanadaRouteTypes( ),
    ] ).then( ( [resporgResults, carrierResults, riskTypeResults, canadaRouteTypes ] ) => {
      this.setState( {
        resporgs: resporgResults,
        carriers: carrierResults,
        riskTypes: riskTypeResults,
        canadaRouteTypes: canadaRouteTypes
      } );
    } ).catch( ( exception ) => {
      this.onHandleException( exception );
    } );

    all();
  }

  getWholesaleCompany( params ) {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'wholesale' );

      api.get( params ).then( ( companyResults ) => {
        resolve( companyResults );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  getResporgs( params ) {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'types/resporgs' );

      api.get( params ).then( ( resporgResults ) => {
        resolve( resporgResults );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  getCarriers( params ) {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'types/carriers' );
      api.get( params ).then( ( carrierResults ) => {
        resolve( carrierResults );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  getRiskTypes( ) {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'types/risktype' );
      api.get().then( ( results ) => {
        resolve( results );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );    
  }

  getCanadaRouteTypes() { 
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'types/canadaroutetype' );
      api.get().then( ( results ) => {
        resolve( results );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );    
  }

  getUtilityDNISRiskTypeOptions() { 
    let options = [];
    const riskTypes = this.state.riskTypes;
    if( riskTypes !== undefined ) {
      if( riskTypes.length > 0 ) {
        for( let index = 0; index < riskTypes.length; index++ ) {
          options.push( {'id': riskTypes[ index ].Risk_Type_ID, 'text': riskTypes[ index ].Code } );
        }
      }
    }
    return options;
  }

  getRouteCanadaOptions() { 
    let canadaRouteTypes = this.state.canadaRouteTypes;
    let options = [];
    if( canadaRouteTypes !== undefined && canadaRouteTypes !== null ) {
      if( canadaRouteTypes.length > 0 ) {
        for( let index = 0; index < canadaRouteTypes.length; index++ ) {
          const row = canadaRouteTypes[ index ];
          options.push(
            {'id': parseInt( row.Code, 10 ), 'text': row.Description }
          );
        }
      }
    }
    return options;
  }
  
  getPlayUtilityDNISOptions() { 
    let options = [
      {'id':0, 'text':'Do Not Play Utility DNIS'},
      {'id':1, 'text':'Play Utility DNIS (Inclusion)'},
      {'id':2, 'text':'Play Utility DNIS (Exclusion)'}
    ];
    return options;
  }

  


  /****************************************************************************
   * EXCEPTION HANDLING
   ***************************************************************************/

  doLogOff() {
    const { dispatch, auth, history } = this.props;
    auth.logout();
    dispatch( clearBugsnagUser() );
    dispatch( clearUserProfile() );
    history.push( '/login' );
  }

  onHandleException( e ) {
    const { dispatch, bugsnag } = this.props;
    const alerts = new Alerts( bugsnag, dispatch );
    const status = e.status === undefined ? 0 : e.status;
    if ( status === 410 ) {
      alerts.INFO( this.title, 'Your session has expired.', 5000 );
      this.doLogOff();
    } else if ( status === 500 ) {
      alerts.INFO( this.title, e.statusText, 5000 );
    } else {
      if ( e.statusText !== undefined ) {
        alerts.CRITICAL( this.title, e, false );
      } else {
        alerts.CRITICAL( this.title, e );
      }
    }
  }

  /****************************************************************************
   * HELPER METHODS
   ***************************************************************************/

  getMdfOwnedOptions() {
    return [
      { id: 0, text: 'Not Owned' },
      { id: 1, text: 'Owned' }
    ];
  }

  getMdfControlledOptions() {
    return [
      { id: 0, text: 'Not Controlled' },
      { id: 1, text: 'Controlled' }
    ];
  }

  getActiveOptions() {
    return [
      { id: 0, text: 'Not Active' },
      { id: 1, text: 'Active' }
    ];
  }

  getInboundSipOptions() {
    return [
      { id: false, text: 'No' },
      { id: true, text: 'Yes' }
    ];
  }

  getResporgOptionsAndValues( data ) {
    const resporgOptions = this.state.resporgs.map( ( resporg ) => {
      return {
        value: resporg.ResporgID,
        label: resporg.RESPORG
      };
    } );

    let resporgValues = [];

    if ( data.resporgs !== undefined ) {
      resporgValues = data.resporgs.map( ( resporg ) => {
        return {
          value: resporg.ResporgID,
          label: resporg.RESPORG,
        };
      } );
    }

    return [resporgOptions, resporgValues];
  }

  getCarrierOptionsAndValues( data ) {
    const carrierOptions = this.state.carriers.map( ( carrier ) => {
      return {
        value: carrier.CarrierID,
        label: carrier.CarrierName,
      };
    } );

    let carrierValues = [];

    if ( data.carriers !== undefined ) {
      carrierValues = data.carriers.map( ( carrier ) => {
        return {
          value: carrier.CarrierID,
          label: carrier.CarrierName,
        };
      } );
    }

    return [carrierOptions, carrierValues];
  }

  /****************************************************************************
   * EVENT HANDLING
   ***************************************************************************/

  onHandleMultiSelectChange( e, columnName ) {
    let selectedItems = [];

    if ( e !== undefined && e.length > 0 ) {
      selectedItems = e.map( ( item ) => {
        return {
          value: item.value,
          label: item.label
        };
      } );
    }

    const payload = {
      target: {
        column: columnName,
        value: selectedItems
      }
    };

    this.onHandleChange( payload );
  }

  onHandleChange( e ) {
    const updatedRow = { ...this.state.row };
    updatedRow[e.target.column] = e.target.value;

    /*
      Special case for multi select column resporgs and carrier. Relabeling
      their keys to be the passed in values from the backend.

      e.target.value = [
        { label: 'ABC01', value: 1 },
        { label: 'AUA47', value: 40 }
      ]
    */
    if ( e.target.column === 'resporgs' ) {
      const resporgs = e.target.value.map( ( resporg ) => {
        return {
          ResporgID: resporg.value,
          RESPORG: resporg.label
        };
      } );

      updatedRow[e.target.column] = resporgs;
    } else if ( e.target.column === 'carriers' ) {
      const carriers = e.target.value.map( ( carrier ) => {
        return {
          CarrierID: carrier.value,
          CarrierName: carrier.label
        };
      } );

      updatedRow[e.target.column] = carriers;
    } else if( e.target.column === 'Play_Utility_DNIS' ) {
      if( parseInt( e.target.value, 10 ) === 0 ) {
        updatedRow.Utility_DNIS = '';
        updatedRow.Utility_DNIS_RiskType_ID = 0;
      }
    }

    this.setState( {
      row: updatedRow,
      changed: true
    }, () => {
      this.props.onChange( updatedRow );
    } );
  }

  /****************************************************************************
   * RENDERS
   ***************************************************************************/

  render() {
    const row = this.state.row;
    const mdfOwnedOptions = this.getMdfOwnedOptions();
    const mdfControlledOptions = this.getMdfControlledOptions();
    const activeOptions = this.getActiveOptions();
    const inboundSipOptions = this.getInboundSipOptions();
    const [resporgOptions, resporgValues] = this.getResporgOptionsAndValues( row );
    const [carrierOptions, carrierValues] = this.getCarrierOptionsAndValues( row );

    let utilityDNISControls = [];

    utilityDNISControls.push(
      <span key="play-utility-dnis-controls-1" className='wholesale-dialog-settings-field'>
        <EditSectionLabel Text='Play Utility Dnis' />
        <EditSectionDropdown columnName="Play_Utility_DNIS" width="250px" value={row.Play_Utility_DNIS} options={this.getPlayUtilityDNISOptions()} onChanged={this.onHandleChange} />
      </span>
    );

    if( parseInt( row.Play_Utility_DNIS, 10 ) !== 0 ) {
      
      utilityDNISControls.push(
        <span key="play-utility-dnis-controls-2" className='wholesale-dialog-settings-field'>
          <EditSectionLabel Text='Utility DNIS' />
          <EditSectionInput columnName='Utility_DNIS' value={row.Utility_DNIS} width='250px' onChanged={this.onHandleChange} />
        </span>
      );

      utilityDNISControls.push(
        <span key="play-dnis-controls-3" className='wholesale-dialog-settings-field'>
          <EditSectionLabel Text='Utility Dnis Risk Type' />
          <EditSectionDropdown columnName="Utility_DNIS_RiskType_ID" width="250px" value={row.Utility_DNIS_RiskType_ID} options={this.getUtilityDNISRiskTypeOptions()} onChanged={this.onHandleChange} />
        </span>
      );
      
    }

    return (
      <div className='wholesale-dialog-settings-content'>
        <span className='wholesale-dialog-settings-group'>
          <span className='wholesale-dialog-settings-field'>
            <EditSectionLabel Text='Company ID' />
            <EditSectionLabel Text={row.Company_ID} hilite />
          </span>
          <span className='wholesale-dialog-settings-field'>
            <EditSectionLabel Text='Company' />
            <EditSectionInput columnName='Company' value={row.Company} width='250px' onChanged={this.onHandleChange} autoFocus={true} />
          </span>
          <span className='wholesale-dialog-settings-field'>
            <EditSectionLabel Text='Default DNIS' />
            <EditSectionInput columnName='DEFDNIS' value={row.DEFDNIS} width='250px' onChanged={this.onHandleChange} />
          </span>
        </span>
        <span className='wholesale-dialog-settings-group'>
          <span className='wholesale-dialog-settings-field'>
            <EditSectionLabel Text='Address' />
            <EditSectionInput columnName='Address' value={row.Address} width='250px' onChanged={this.onHandleChange} />
          </span>
          <span className='wholesale-dialog-settings-field'>
            <EditSectionLabel Text='City' />
            <EditSectionInput columnName='City' value={row.City} width='250px' onChanged={this.onHandleChange} />
          </span>
          <span className='wholesale-dialog-settings-field'>
            <EditSectionLabel Text='State' />
            <EditSectionInput columnName='State' value={row.State} width='250px' onChanged={this.onHandleChange} />
          </span>
          <span className='wholesale-dialog-settings-field'>
            <EditSectionLabel Text='Zipcode' />
            <EditSectionInput columnName='ZipCode' value={row.ZipCode} width='250px' onChanged={this.onHandleChange} />
          </span>
        </span>
        <span className='wholesale-dialog-settings-group'>
          <span className='wholesale-dialog-settings-field'>
            <EditSectionLabel Text='MDF Owned' />
            <EditSectionDropdown columnName='MDF_Owned' value={row.MDF_Owned} options={mdfOwnedOptions} width='250px' onChanged={this.onHandleChange} />
          </span>
          <span className='wholesale-dialog-settings-field'>
            <EditSectionLabel Text='MDF Controlled' />
            <EditSectionDropdown columnName='MDF_Controlled' value={row.MDF_Controlled} options={mdfControlledOptions} width='250px' onChanged={this.onHandleChange} />
          </span>
          <span className='wholesale-dialog-settings-field'>
            <EditSectionLabel Text='Active' />
            <EditSectionDropdown columnName='Active' value={row.Active} options={activeOptions} width='250px' onChanged={this.onHandleChange} />
          </span>
          <span className='wholesale-dialog-settings-field'>
            <EditSectionLabel Text='Inbound SIP' />
            <EditSectionDropdown columnName='Inbound_SIP' value={row.Inbound_SIP} options={inboundSipOptions} width='250px' onChanged={this.onHandleChange} />
          </span>
        </span>
        <span className='wholesale-dialog-settings-group'>
          <span className='wholesale-dialog-settings-field'>
            <EditSectionLabel Text='Resporgs' />
            <Select style={{ width: '250px' }} name='resporgs' placeholder='Select Resporg(s)' value={resporgValues} options={resporgOptions} multi={true} clearable={true} scrollMenuIntoView={false} onChange={( e ) => this.onHandleMultiSelectChange( e, 'resporgs' )} />
          </span>
          <span className='wholesale-dialog-settings-field'>
            <EditSectionLabel Text='Carriers' />
            <Select style={{ width: '250px' }} name='carriers' placeholder='Select Carrier(s)' value={carrierValues} options={carrierOptions} multi={true} clearable={true} scrollMenuIntoView={false} onChange={( e ) => this.onHandleMultiSelectChange( e, 'carriers' )} />
          </span>
        </span>
        <span className='wholesale-dialog-settings-group'>
          <span className='wholesale-dialog-settings-field'>
            <EditSectionCheckBox id='USE_DID_SHIELD' checked={row.USE_DID_SHIELD === 1 ? true : false} label={'Use DID Shield'} onChanged={this.onHandleChange} />
          </span>
          <span className='wholesale-dialog-settings-field'>
            <EditSectionLabel Text='Route Canada To Default' />
            <EditSectionDropdown columnName='Route_Canada_To_Default' value={row.Route_Canada_To_Default} options={this.getRouteCanadaOptions()} width='250px' onChanged={this.onHandleChange} />
          </span>
        </span>
        <span className='wholesale-dialog-settings-group'>
          {utilityDNISControls}
        </span>
      </div>
    );
  }
}

export default withRouter(
  connect(
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( WholesaleSettings ) );


// WEBPACK FOOTER //
// ./src/content/wholesale/companies/components/WholesaleSettings.js